"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var shared;
        (function (shared) {
            var updateFormEntryDialog;
            (function (updateFormEntryDialog) {
                class InitArgs {
                    constructor() {
                        this.closeModal = false;
                    }
                }
                function init(args) {
                    addEvents();
                    if (args.closeModal)
                        appn.iframe.closeModal();
                }
                updateFormEntryDialog.init = init;
                function addEvents() {
                    $('#updatedAttachFile').on('change', function (e) {
                        const fileUploadWidget = $('#updatedAttachFile');
                        const btnParent = fileUploadWidget.closest('.btn-file');
                        const text = btnParent.find('.fileinput-new.lead');
                        if (appn.utils.hasValue(text)) {
                            const updatedFile = fileUploadWidget[0].files[0];
                            text.attr('style', 'display: inline-flex; align-items: center;');
                            text.html(`<i class="fa-2x mr-2"></i> ${updatedFile.name}`);
                        }
                    });
                }
            })(updateFormEntryDialog = shared.updateFormEntryDialog || (shared.updateFormEntryDialog = {}));
        })(shared = views.shared || (views.shared = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
